import { useMutation, useQuery } from "@tanstack/react-query";

import { ApiClientClass, useApi } from "./useApi";
import PaymentClient from "../clients/PaymentClient";

export const useCreateCryptoPayment = (investmentId: string, options = {}) => {
  const api = useApi(PaymentClient as unknown as ApiClientClass<PaymentClient>);

  return useMutation((data) => api.createCryptoPayment(investmentId, data), options);
};

export const useCancelCryptoPayment = (investmentId: string, options = {}) => {
  const api = useApi(PaymentClient as unknown as ApiClientClass<PaymentClient>);

  return useMutation((data) => api.cancelCryptoPayment(investmentId, data), options);
};

export const usePaymentStatus = (paymentId: string, options = {}) => {
  const api = useApi(PaymentClient as unknown as ApiClientClass<PaymentClient>);

  return useQuery(["payments", paymentId, "payment"], () => api.getCryptoStatus(paymentId), {
    enabled: !!paymentId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
  });
};

export const useResumePayment = (investmentId: string, options = {}) => {
  const api = useApi(PaymentClient as unknown as ApiClientClass<PaymentClient>);

  return useQuery(["crypto", investmentId, "resume"], () => api.resumeCryptoPayment(investmentId), {
    enabled: !!investmentId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
  });
};
